import React, { PureComponent } from 'react';

const data = {
  'Illegale Tötung': 35,
  'Illegale Tötung in %': 12,
  'Management': 3,
  'Management in %': 1,
  'natürlich': 25,
  'natürlich in %': 9,
  'unklar': 15,
  'unklar in %': 5,
  'Verkehrsunfall': 208,
  'Verkehrsunfall in %': 73,
  'gesamt_abs': 286
};

class WolfBar extends PureComponent {
  render() {
    return (
      <div className="wolfbar">
        <div className="wolfbar__title">Todesursache der Wölfe</div>
        <div className="wolfbar__vis">
          <div className="wolfbar__vis-bar" style={{ width: '73%', background: '#FF6F00' }}>
            <div className="wolfbar__vis-label top label1">getötet <strong>86%</strong></div>
            <div className="wolfbar__vis-label bottom label4">Verkehrsunfall (73%)</div>
          </div>
          <div className="wolfbar__vis-bar" style={{ width: '12%', background: '#FF9A4C' }}>
            <div className="wolfbar__vis-label bottom label5">Illegale Tötung (12%)</div>
          </div>
          <div className="wolfbar__vis-bar" style={{ width: '1%', background: '#FFB77F' }}>
            <div className="wolfbar__vis-label bottom label6">legaler Abschuss (1%)</div>
          </div>
          <div className="wolfbar__vis-bar" style={{ width: '9%', background: '#5A5A5A' }}>
            <div className="wolfbar__vis-label top label2">natürlich gestorben <strong>9%</strong></div>
          </div>
          <div className="wolfbar__vis-bar" style={{ width: '5%', background: '#A3A3A3' }}>
            <div className="wolfbar__vis-label top label3">unklar <strong>5%</strong></div>
          </div>
        </div>
      </div>
    );
  }
}

export default WolfBar;
